import { render, staticRenderFns } from "./UseWaterRecord.vue?vue&type=template&id=47023dfa&scoped=true&"
import script from "./UseWaterRecord.vue?vue&type=script&lang=js&"
export * from "./UseWaterRecord.vue?vue&type=script&lang=js&"
import style0 from "./UseWaterRecord.vue?vue&type=style&index=0&id=47023dfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47023dfa",
  null
  
)

export default component.exports